<template>
  <div>
    <NBar title="异常设备"/>
    <div class="tips-div">设备最新活动时间</div>
    <div style="margin-bottom: 10px;" v-for="(item, index) in list" :key="index">
      <div class="item-div">
        <span style="margin-left: 10px;font-size:14px;">{{item.name}}</span>
        <span style="margin-right: 10px;">共{{item.deviceList.length}}台</span>
      </div>
      <nut-cell v-for="(sub, subIndex) in item.deviceList" :key="subIndex">
        <span slot="title" style="font-size: 12px;">{{sub.name + sub.deviceId}}</span>
        <span slot="desc" style="font-size: 12px;"
              :style="{color:sub.isOnline === 1 ? '#22bd47' : '#ff524c'}">{{sub.isOnline === 1 ? '在线' : '离线'}}</span>
      </nut-cell>
    </div>
  </div>
</template>

<script>
/**
 * 异常设备
 */
export default {
  name: 'AbnormalDevice',
  data () {
    return {
      list: []
    }
  },
  activated () {
    this.getData()
  },
  methods: {
    getData () {
      this.$api.post({
        url: '/device/api/device/address/device-list',
      }).then(res => {
        this.list = res.data
      })
    }
  }
}
</script>

<style scoped>
  >>> .nut-cell-box {
    min-height: 40px;
  }

  .tips-div {
    color: #666666;
    height: 35px;
    margin: 0 10px;
    display: flex;
    align-items: center;
  }

  .item-div {
    background-color: white;
    display: flex;
    height: 40px;
    justify-content: space-between;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/home/AbnormalDevice.vue